import { FormattedMessage, useIntl } from 'react-intl';
import * as reportApi from '../api/PomReport';
import { IPomReportCategoryData, IPomReportCategorySumItem, IPomReportDataCategory, IPomReportDataInfo, IPomReportDataSubCategory, IPomReportSubCategoryData, IPomReportTotalSumItem } from '../util/DataModelInterface'
import parse from 'html-react-parser';
import { Fragment, useEffect, useState } from 'react';
import { Nav } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { formatFinNumber } from '../util/FormatDateUtil';

export interface IPomListProps {
  categories: IPomReportCategoryData[];
  reportData: IPomReportDataCategory;
  reportInfoData: IPomReportDataInfo | IPomReportTotalSumItem;
  reportCatSumData: {[x: string]: IPomReportCategorySumItem};
  period: string;
  companyName: string;
  periodEnd?: string;
  summary?: boolean;
}

export const PomList = (props: IPomListProps) => {
  const intl = useIntl();
  const lang = intl.locale;
  const [tableheadings2, setTableheadings2] = useState([] as any[]);
  const [link, setLink] = useState(false);

  const {categories, reportData, reportInfoData, reportCatSumData, period, companyName, periodEnd } = props;

  const year = period.split("-")[0];
  const month = parseInt(period.split("-")[1]);

  const tableheadings=[{'label':'pricegroup', 'colspan': 1}, {'label':'fin', 'colspan': 3}, {'label':'aland', 'colspan': 3}, {'label':'b2b', 'colspan': 3}];

  useEffect(() => {
    setLink(props.companyName === '');
    let pcsTxt = intl.formatMessage({id: 'unit.pieces'});
    setTableheadings2(
      ['',{'label':'fin', 'symbol':'€'}, {'label':'fin', 'symbol':'kg'}, {'label':'fin', 'symbol': pcsTxt},
          {'label':'aland', 'symbol':'€'}, {'label':'aland', 'symbol':'kg'}, {'label':'aland', 'symbol': pcsTxt},
          {'label':'b2b', 'symbol':'€'}, {'label':'b2b', 'symbol':'kg'}, {'label':'b2b', 'symbol': pcsTxt}
      ]
    );
  }, [intl, props.companyName]);

  const calculateRowSum = (subData: any, price: string, isNum?: boolean) => {
    let fin = typeof subData.amount_fin !== 'number' ? 0 : parseFloat(subData.amount_fin);
    let al = typeof subData.amount_aland !== 'number' ? 0 : parseFloat(subData.amount_aland);
    let b2b = typeof subData.amount_b2b !== 'number' ? 0 : parseFloat(subData.amount_b2b);
    let sumVal = fin + al + b2b;
    let sumEur = parseFloat(price) * sumVal;
    let result;
    if (!isNum) {
      result = formatFinNumber(sumEur);
    } else {
      result = sumEur;
    }
    return result;
  }

  const getCorrectPrice = (priceObj: any) => {
    let reportPeriodDate = new Date(`${year}-${month < 10 ? '0' + month : month}-10`);
    let priceList = Object.keys(priceObj).sort().reverse();

    let foundPrice = priceList.find((yyyymm) => {
      let priceDate = new Date(`${yyyymm}-9`);
      return reportPeriodDate > priceDate;
    })
    if (foundPrice) {
      return priceObj[foundPrice];
    } else {
      console.error("Price not found!");
      return "0";
    }
  }

  const exportReport = (e: { preventDefault: () => void; } | undefined) => {
    e?.preventDefault();
    let reportJsonData = [] as any;

    categories.forEach((cat: IPomReportCategoryData) => {
      let code = cat.code;
      let catData = reportData[code];
      let catSumData = reportCatSumData[code];
      cat.subs.forEach((sub: IPomReportSubCategoryData, index: number) => {
        let subcategory = sub.code;
        let subPrice = getCorrectPrice(sub.price);//sub.price;
        let subPriceMod = parseFloat(subPrice);
        let subCat = catData?.find((subItem) => subItem[subcategory]);
        let subData = subCat ? subCat[subcategory] : undefined;

        let row = {} as any;
        if (sub) {
          let subName = lang === "fi-FI" ? sub.name_fi : (lang === "en-GB" ? sub.name_en : sub.name_se);
          row[intl.formatMessage({id: 'report.header.pricegroup'})] = sub.code + " " + subName;
          row[intl.formatMessage({id: 'report.header.price'})] = subPriceMod;
          if (sub.unit === "kg") {
            row[intl.formatMessage({id: 'report.header.fin.kg'})] = subData?.amount_fin ? subData.amount_fin : "";
            row[intl.formatMessage({id: 'report.header.fin.pc'})] = "";
            row[intl.formatMessage({id: 'report.header.aland.kg'})] = subData?.amount_aland ? subData.amount_aland : "";
            row[intl.formatMessage({id: 'report.header.aland.pc'})] = "";
            row[intl.formatMessage({id: 'report.header.b2b.kg'})] = subData?.amount_b2b ? subData.amount_b2b : "";
            row[intl.formatMessage({id: 'report.header.b2b.pc'})] = "";
          } else {
            row[intl.formatMessage({id: 'report.header.fin.kg'})] = "";
            row[intl.formatMessage({id: 'report.header.fin.pc'})] = subData?.amount_fin ? subData.amount_fin : "";
            row[intl.formatMessage({id: 'report.header.aland.kg'})] = "";
            row[intl.formatMessage({id: 'report.header.aland.pc'})] = subData?.amount_aland ? subData.amount_aland : "";
            row[intl.formatMessage({id: 'report.header.b2b.kg'})] = "";
            row[intl.formatMessage({id: 'report.header.b2b.pc'})] = subData?.amount_b2b ? subData.amount_b2b : "";
          }
          row[intl.formatMessage({id: 'report.header.sum'})] = subData ? calculateRowSum(subData, subPrice, true) : "";
          reportJsonData.push(row);
        }
      });
      // catSumData
      let row = {} as any;
      let totalCatFee = catSumData?.total_fin_eur + catSumData?.total_aland_eur + catSumData?.total_b2b_eur;
      row[intl.formatMessage({id: 'report.header.pricegroup'})] = "";
      row[intl.formatMessage({id: 'report.header.price'})] = "";
      row[intl.formatMessage({id: 'report.header.fin.kg'})] = catSumData?.total_fin_kg ? catSumData?.total_fin_kg : "";
      row[intl.formatMessage({id: 'report.header.fin.pc'})] = catSumData?.total_fin_pcs ? catSumData?.total_fin_pcs : "";
      row[intl.formatMessage({id: 'report.header.aland.kg'})] = catSumData?.total_aland_kg ? catSumData?.total_aland_kg :"";
      row[intl.formatMessage({id: 'report.header.aland.pc'})] = catSumData?.total_aland_pcs ? catSumData?.total_aland_pcs : "";
      row[intl.formatMessage({id: 'report.header.b2b.kg'})] = catSumData?.total_b2b_kg ? catSumData?.total_b2b_kg : "";
      row[intl.formatMessage({id: 'report.header.b2b.pc'})] = catSumData?.total_b2b_pcs ? catSumData?.total_b2b_pcs : "";
      row[intl.formatMessage({id: 'report.header.sum'})] = totalCatFee;
      reportJsonData.push(row);
    });

    // empty row
    let row_empty = {} as any;
    row_empty[intl.formatMessage({id: 'report.header.pricegroup'})] = "";
    row_empty[intl.formatMessage({id: 'report.header.price'})] = "";
    row_empty[intl.formatMessage({id: 'report.header.fin.kg'})] = "";
    row_empty[intl.formatMessage({id: 'report.header.fin.pc'})] = "";
    row_empty[intl.formatMessage({id: 'report.header.aland.kg'})] = "";
    row_empty[intl.formatMessage({id: 'report.header.aland.pc'})] = "";
    row_empty[intl.formatMessage({id: 'report.header.b2b.kg'})] = "";
    row_empty[intl.formatMessage({id: 'report.header.b2b.pc'})] = "";
    row_empty[intl.formatMessage({id: 'report.header.sum'})] = "";
    reportJsonData.push(row_empty);

    // Total total
    let row_total = {} as any;
    let totalFee = reportInfoData?.total_fin_eur + reportInfoData?.total_aland_eur + reportInfoData?.total_b2b_eur;
    row_total[intl.formatMessage({id: 'report.header.pricegroup'})] = "";
    row_total[intl.formatMessage({id: 'report.header.price'})] = "";
    row_total[intl.formatMessage({id: 'report.header.fin.kg'})] = reportInfoData?.total_fin_kg ? reportInfoData?.total_fin_kg : "";
    row_total[intl.formatMessage({id: 'report.header.fin.pc'})] = reportInfoData?.total_fin_pcs ? reportInfoData?.total_fin_pcs : "";
    row_total[intl.formatMessage({id: 'report.header.aland.kg'})] = reportInfoData?.total_aland_kg ? reportInfoData?.total_aland_kg :"";
    row_total[intl.formatMessage({id: 'report.header.aland.pc'})] = reportInfoData?.total_aland_pcs ? reportInfoData?.total_aland_pcs : "";
    row_total[intl.formatMessage({id: 'report.header.b2b.kg'})] = reportInfoData?.total_b2b_kg ? reportInfoData?.total_b2b_kg : "";
    row_total[intl.formatMessage({id: 'report.header.b2b.pc'})] = reportInfoData?.total_b2b_pcs ? reportInfoData?.total_b2b_pcs : "";
    row_total[intl.formatMessage({id: 'report.header.sum'})] = totalFee;
    reportJsonData.push(row_total);
    console.log("row_total", row_total);

    console.log("reportJsonData", reportJsonData);

    reportApi.exportReport(
    { header: companyName + period + (periodEnd ? "-" + periodEnd : ""),
      data: reportJsonData
    })
  }

  const getReportRows = (cat: IPomReportCategoryData) => {
    const subs = cat.subs;
    let catReportData = reportData[cat.code] as IPomReportDataSubCategory[];
    // console.log("catReportData", catReportData);
    return subs.map( (sub: IPomReportSubCategoryData, index: number) => {
      let subcategory = sub.code;
      // let subPrice = getCorrectPrice(sub.price);//sub.price;
      let subName = lang === "fi-FI" ? sub.name_fi : (lang === "en-GB" ? sub.name_en : sub.name_se);
      let subData = {} as any;
      // console.log("subcategory", subcategory);
      let eur_fin = "";
      let amount_fin = "";
      let eur_al = "";
      let amount_al = "";
      let eur_b2b = "";
      let amount_b2b = "";
      if (catReportData && Array.isArray(catReportData)) {
        let subCat = catReportData.find((subItem) => subItem[subcategory]);
        subData = subCat ? subCat[subcategory] : undefined;
        if (subData) {
            if (subData.amount_fin)
                amount_fin = (typeof subData.amount_fin === 'number') ? formatFinNumber(subData.amount_fin) : subData.amount_fin;
            if (subData.amount_aland)
                amount_al = (typeof subData.amount_aland === 'number') ? formatFinNumber(subData.amount_aland) : subData.amount_aland;
            if (subData.amount_b2b)
                amount_b2b = (typeof subData.amount_b2b === 'number') ? formatFinNumber(subData.amount_b2b) : subData.amount_b2b;
            eur_fin = subData.eur_fin ? formatFinNumber(subData.eur_fin) : "";
            eur_al = subData.eur_aland ? formatFinNumber(subData.eur_aland) : "";
            eur_b2b = subData.eur_b2b ? formatFinNumber(subData.eur_b2b) : "";
        } else if (props.summary) {
          // Skip empty lines, if summary only
          return null;
        }
      }
      return (
        <Fragment key={cat.code + "_" + index}>
          <tr key={index}>
            <td>
              <span className="column-label">{tableheadings[0].label}</span>
              { link &&
                <Nav.Link
                  as={NavLink}
                  to="/reportsAdmin/reportedPom"
                  state={{ periodStart: period, periodEnd: periodEnd, category: sub.code, name: subName }}
                  className={"btn btn-link"}>
                    <span>{sub.code} {subName}</span>
                </Nav.Link>
              }
              { !link && <span>{sub.code} {subName}</span> }
            </td>
            <td>
              <span className="column-label"><span className="sr-only">{ intl.formatMessage({id: 'report.header.fin'}) }</span>€</span>
              <span>{eur_fin}</span>
            </td>
            <td>
              <span className="column-label"><span className="sr-only">{ intl.formatMessage({id: 'report.header.fin'}) }</span>kg</span>
              <span>{(sub.unit === "kg") && amount_fin}</span>
            </td>
            <td>
              <span className="column-label"><span className="sr-only">{ intl.formatMessage({id: 'report.header.fin'}) }</span><FormattedMessage id="unit.pieces"/></span>
              <span>{(sub.unit === "kpl") && amount_fin}</span>
            </td>
            <td>
              <span className="column-label"><span className="sr-only">{ intl.formatMessage({id: 'report.header.aland'}) }</span>€</span>
              <span>{eur_al}</span>
            </td>
            <td>
              <span className="column-label"><span className="sr-only">{ intl.formatMessage({id: 'report.header.aland'}) }</span>kg</span>
              <span>{(sub.unit === "kg") && amount_al}</span>
            </td>
            <td>
              <span className="column-label"><span className="sr-only">{ intl.formatMessage({id: 'report.header.aland'}) }</span><FormattedMessage id="unit.pieces"/></span>
              <span>{(sub.unit === "kpl") && amount_al}</span>
            </td>
            <td>
              <span className="column-label"><span className="sr-only">{ intl.formatMessage({id: 'report.header.b2b'}) }</span>€</span>
              <span>{eur_b2b}</span>
            </td>
            <td>
              <span className="column-label"><span className="sr-only">{ intl.formatMessage({id: 'report.header.b2b'}) }</span>kg</span>
              <span>{(sub.unit === "kg") && amount_b2b}</span>
            </td>
            <td>
              <span className="column-label"><span className="sr-only">{ intl.formatMessage({id: 'report.header.b2b'}) }</span><FormattedMessage id="unit.pieces"/></span>
              <span>{(sub.unit === "kpl") && amount_b2b}</span>
            </td>
          </tr>
        </Fragment>
      );
    })
  }

  const getTotals = (totSums: IPomReportCategorySumItem | IPomReportDataInfo | IPomReportTotalSumItem, ind: string) => {
    let classes = ind === "sub" ? "subtotal" : "total";
    if(!totSums) {
      return (
        <tr className={classes} key={"rowtotal_" + ind}>
          <td colSpan={10}><FormattedMessage id="report.details.sum"/></td>
        </tr>
      );
    }

    return (
      <>
        <tr className={classes} key={"rowtotal_" + ind}>
          <td><FormattedMessage id="report.details.sum"/></td>
          <td>
            <span className={classes}></span>
            <span>{totSums.total_fin_eur ? formatFinNumber(totSums.total_fin_eur) : ""}</span>
          </td>
          <td>
            <span className={classes}></span>
            <span>{totSums.total_fin_kg ? formatFinNumber(totSums.total_fin_kg) : ""}</span>
          </td>
          <td>
            <span className={classes}></span>
            <span>{totSums.total_fin_pcs ? formatFinNumber(totSums.total_fin_pcs,) : ""}</span>
          </td>
          <td>
            <span className={classes}></span>
            <span>{totSums.total_aland_eur ? formatFinNumber(totSums.total_aland_eur) : ""}</span>
          </td>
          <td>
            <span className={classes}></span>
            <span>{totSums.total_aland_kg ? formatFinNumber(totSums.total_aland_kg) : ""}</span>
          </td>
          <td>
            <span className={classes}></span>
            <span>{totSums.total_aland_pcs ? formatFinNumber(totSums.total_aland_pcs) : ""}</span>
          </td>
          <td>
            <span className={classes}></span>
            <span>{totSums.total_b2b_eur ? formatFinNumber(totSums.total_b2b_eur) : ""}</span>
          </td>
          <td>
            <span className={classes}></span>
            <span>{totSums.total_b2b_kg ? formatFinNumber(totSums.total_b2b_kg) : ""}</span>
          </td>
          <td>
            <span className={classes}></span>
            <span>{totSums.total_b2b_pcs ? formatFinNumber(totSums.total_b2b_pcs) : ""}</span>
          </td>
        </tr>
      </>
    );
  }

  const getReportCategory = (cat: IPomReportCategoryData, catIndex: number) => {
    let title = lang === "fi-FI" ? parse(cat.name_fi) : (lang === "en-GB" ? parse(cat.name_en) : parse(cat.name_se));
    let catReportData = reportData[cat.code] as IPomReportDataSubCategory[];
    if (props.summary && (!catReportData || catReportData.length === 0) ) {
      // Skip empty category, if summary only
      return null;
    }
    return (
      <Fragment key={catIndex}>
        <tr key={"row_" + catIndex}>
          <td colSpan={10} className="subheader">
            <span className="column-label">{tableheadings[0].label}</span>
            { link &&
              <Nav.Link
                as={NavLink}
                to="/reportsAdmin/reportedPom"
                state={{ periodStart: period, periodEnd: periodEnd, category: cat.code, name: title }}
                className={"btn btn-link"}>
                  <span>{cat.view_code} {title}</span>
              </Nav.Link>
            }
            { !link && <span>{cat.view_code} {title}</span> }
          </td>
        </tr>
        { getReportRows(cat) }
        { getTotals(reportCatSumData[cat.code], "sub") }
      </Fragment>
    )
  }

  return (
    <>
      { !props.summary &&
      <div className="toolbar">
        <button className="btn btn-primary" onClick={(e) => exportReport(e)}>
          <i className="fa fa-download me-2"></i>
          <FormattedMessage id="button.report.download"/>
        </button>
      </div>
      }

      <div id="reportlist">
        <div className="table-responsive ">
          <table className="table table-hover border-bottom ">
            <caption className="sr-only">WEEE reportdata</caption>
            <thead>
              <tr>
                {tableheadings.map( (th, index:number) => (
                    <th key={index} colSpan={th.colspan}>
                        <FormattedMessage id={`report.header.${th.label}`}/>
                    </th>
                ))}
              </tr>
              <tr>
                {tableheadings2.map( (symbolObj: any, index:number) => (
                    <th key={index}>
                        <span className="sr-only">{symbolObj.label}</span>
                        {symbolObj.symbol}
                    </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {categories.length > 0 && categories.map( (cat: IPomReportCategoryData, catIndex: number) => (
                getReportCategory(cat, catIndex)
              ))}
            </tbody>
            <tfoot role="row">
              { Object.keys(reportInfoData).length > 0 && getTotals(reportInfoData, "info") }
            </tfoot>
          </table>
        </div>
      </div>
    </>
  );
};